export default "__VITE_ASSET__DBYNWzmf__"